import React, { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { StoreContext } from "../../context/StoreContext";
import {
  DEFAULT_LOCALE,
  getLocaleFromPath,
  withLocale,
} from "../../../config/locales";

const ProtectedRoute = ({ children }) => {
  const { isLoggedIn } = useContext(StoreContext);
  const { pathname } = useLocation();

  if (!isLoggedIn) {
    const currentLocale = getLocaleFromPath(pathname) ?? DEFAULT_LOCALE;
    return <Navigate to={withLocale(currentLocale, "/login")} replace />;
  }
  return children;
};

export default ProtectedRoute;
